import React from "react";

export default function DMASignal({ price, dma200 }) {

  const diff = ((price - dma200) / dma200) * 100;

  let signal = "Neutral";
  let color = "from-gray-400 to-gray-500";

  if (diff > 3) {
    signal = "Bullish";
    color = "from-green-400 to-green-600";
  } else if (diff < -3) {
    signal = "Bearish";
    color = "from-red-400 to-red-600";
  }

  // position of indicator
  const position = Math.max(0, Math.min(100, 50 + diff * 5));

  return (
    <div className="flex items-center justify-center w-full bg-white shadow-lg rounded-xl p-5 border lg:h-[150px]">
      <div className="w-full">
      <div className="flex justify-between text-sm font-medium mb-3">
        <span className="text-red-500">Bearish</span>
        <span className="text-gray-500">Neutral</span>
        <span className="text-green-600">Bullish</span>
      </div>

      {/* Signal Bar */}
      <div className="relative w-full h-3 rounded-full bg-gradient-to-r from-red-500 via-gray-300 to-green-500">

        {/* Indicator */}
        <div
          className="absolute -top-1 w-5 h-5 bg-white border-2 border-gray-700 rounded-full shadow-md transition-all duration-500"
          style={{ left: `${position}%`, transform: "translateX(-50%)" }}
        />

      </div>

      <div className="mt-4 flex justify-between items-center">

        <div>
          <p className="text-sm text-gray-500">Price</p>
          <p className="font-semibold">{price}</p>
        </div>

        <div>
          <p className="text-sm text-gray-500">200 DMA</p>
          <p className="font-semibold">{dma200}</p>
        </div>

        <div className="text-right">
          <p className="text-sm text-gray-500">Signal</p>
          <p
            className={`font-bold bg-gradient-to-r ${color} bg-clip-text text-transparent`}
          >
            {signal}
          </p>
        </div>

      </div>
      </div>
    </div>
  );
}